import * as React from 'react';
import type { SVGProps } from 'react';

const SvgRectangleLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={416} height={112} fill="none" {...props}>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M338.61 10.691H10v87.397L338.61 10.69ZM0 .691v110.404L415.117.691H0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRectangleLeft;
